import React from 'react';

export default function BoxContainerTitle({ className, children, fontSize = 'fs-md' }) {
  const classes = `${className} ${fontSize}`;

  return <div className={`mb-1 font-weight-500 ${classes}`}>{children}</div>;
}
